import { MultipleChoiceSelectionGroup } from 'Components/FormField/MultipleChoiceSelectionGroup/MultipleChoiceSelectionGroup';
import { UnansweredQuestionMarker } from 'Components/RequiresAttentionMarker/UnansweredQuestionMarker';
import { Text, TextProps } from 'Components/Text/Text';
import { IrqQuestionMultipleSelect, IrqQuestionType } from 'Models/InherentRisk';

interface QuestionMultipleSelectProps {
    formFieldId: string;
    onAnswerChanged: (answerIndices: number[]) => void;
    question: IrqQuestionMultipleSelect;
    questionNumber: number;
    showUnansweredQuestionMarker: boolean;

    disabled?: boolean;
    questionTextVariant?: TextProps['variant'];
}

/**
 * Renders a question that requires the user to select one or more choices.
 * Currently used only for the IRQ.
 */
export const QuestionMultipleSelect = (props: QuestionMultipleSelectProps) => {
    return (
        <>
            <Text variant={props.questionTextVariant ?? 'Text2'}>{`${props.questionNumber}. ${props.question.text}`}</Text>
            {props.showUnansweredQuestionMarker && <UnansweredQuestionMarker questionIsRequired questionType={IrqQuestionType.MULTIPLE_SELECT} />}
            <MultipleChoiceSelectionGroup formFieldLabel="Answer" disabled={props.disabled} formFieldId={props.formFieldId} handleChange={props.onAnswerChanged} options={props.question.options.map((option) => option.text)} selectedOptions={props.question.answer} />
        </>
    );
};
